'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointsAndSvg = function (_React$Component) {
  (0, _inherits3.default)(PointsAndSvg, _React$Component);

  function PointsAndSvg(props) {
    (0, _classCallCheck3.default)(this, PointsAndSvg);
    return (0, _possibleConstructorReturn3.default)(this, (PointsAndSvg.__proto__ || (0, _getPrototypeOf2.default)(PointsAndSvg)).call(this, props));
  }

  (0, _createClass3.default)(PointsAndSvg, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          cName = _props.cName,
          generalClass = _props.generalClass;


      return _react2.default.createElement(
        'div',
        { className: "pointsAndSvg " + generalClass },
        _react2.default.createElement('span', { className: 'littlePoint' }),
        _react2.default.createElement('span', { className: 'littlePoint middle' }),
        _react2.default.createElement('span', { className: 'bigPoint' }),
        _react2.default.createElement('i', { className: icon, onClick: this.props.clickIcon }),
        _react2.default.createElement('span', { className: 'bigPoint' }),
        _react2.default.createElement('span', { className: 'littlePoint middle' }),
        _react2.default.createElement('span', { className: 'littlePoint' }),
        _react2.default.createElement(
          'div',
          { className: 'circles' },
          _react2.default.createElement('span', { className: "circle photo" + cName }),
          _react2.default.createElement('span', { className: "circle photo" + cName }),
          _react2.default.createElement('span', { className: "circle photo" + cName }),
          _react2.default.createElement('span', { className: "circle photo" + cName }),
          _react2.default.createElement('span', { className: "circle photo" + cName }),
          _react2.default.createElement('span', { className: "circle photo" + cName })
        )
      );
    }
  }]);
  return PointsAndSvg;
}(_react2.default.Component);

exports.default = PointsAndSvg;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PointsAndSvg/PointsAndSvg.js
// module id = 803
// module chunks = 0